import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { Job } from '@sites/data-hmm/hmm-job';
import { produce } from 'immer';
import { jobServiceActions } from './job.actions';

export interface JobEntityState extends EntityState<Job> {
  listError?: Error;
  watchError?: Error;
}

export const jobAdapter: EntityAdapter<Job> = createEntityAdapter<Job>({
  selectId: selectJobId,
});

export function selectJobId(job: Job) {
  return job.workflowId;
}

export const initialJobState: JobEntityState = jobAdapter.getInitialState();

export const jobReducer = createReducer(
  initialJobState,
  on(jobServiceActions.listSuccess, (state, { jobs }): JobEntityState => {
    return jobAdapter.setAll(
      jobs,
      produce(state, (draft) => {
        draft.listError = undefined;
      })
    );
  }),
  on(
    jobServiceActions.listFailure,
    jobServiceActions.cancelFailure,
    (state, { error }): JobEntityState => {
      return produce(state, (draft) => {
        draft.listError = error;
      });
    }
  ),
  on(jobServiceActions.upsertJob, (state, { job }): JobEntityState => {
    return jobAdapter.upsertOne(job, state);
  }),
  on(jobServiceActions.watchSuccess, (state, { job }): JobEntityState => {
    return jobAdapter.upsertOne(
      job,
      produce(state, (draft) => {
        draft.watchError = undefined;
      })
    );
  }),
  on(jobServiceActions.watchFailure, (state, { error }): JobEntityState => {
    return produce(state, (draft) => {
      draft.watchError = error;
    });
  })
);
